/**
 * Loaded before Prism, which reads this as it starts: left to itself it would
 * go through the page for `language-*` elements to highlight, writing HTML
 * into them. `highlight.ts` asks it for tokens instead.
 */

const scope = globalThis as { Prism?: { manual?: boolean; disableWorkerMessageHandler?: boolean } };
scope.Prism = { ...scope.Prism, manual: true, disableWorkerMessageHandler: true };

export {};
